export default [
  {
    path: "/",
    redirect: "/es/",
  },
  {
    path: "/title/:slug",
    redirect: function (to: any) {
      const url = "/es/peliculas/" + to.params.slug;
      return { path: url };
    },
  },
  {
    path: "/vizio",
    redirect: function (to: any) {
      const url =
        "/plans-logged/?utm_source=vizio&utm_medium=vizio&utm_campaign=payment&redirect_to=plans";
      console.log("Vizio user recognized");
      return { path: url };
    },
  },
];
